import React, { useEffect } from 'react';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import { Dumbbell, Utensils, CheckCircle } from 'lucide-react';

const Products: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <div className="relative pt-20 py-20 mt-10 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-semibold text-white mb-6 text-glow">
            WHAT WE OFFER
          </h1>
          <div className="w-16 h-1 bg-red-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-12">
            Explore our wide range of products and services to help you get in the best shape possible
          </p>
        </div>
      </div>

      {/* Products Grid Section */}
      <div className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Recipe Book */}
            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
              <div className="text-red-600 mb-6">
                <Utensils size={48} />
              </div>
              <div className="mb-6">
                <img src="/recipebook.png" alt="Recipe Book" className="w-full h-[22rem] md:h-[31rem] object-cover rounded-md shadow-md" />
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-white">Recipe Book</h3>
              <p className="text-gray-300 mb-6">
                A comprehensive collection of delicious and nutritious recipes designed to support your fitness goals. Each recipe includes detailed macros and preparation instructions.
              </p>
              <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/high-protein-recipe-book/" target="_blank" rel="noopener noreferrer">GET THE RECIPE BOOK</Button>
            </div>

            {/* Guide for Picky Eaters */}
            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
              <div className="text-red-600 mb-6">
                <CheckCircle size={48} />
              </div>
              <div className="mb-6">
                <img src="/calorieshake.png" alt="Calories Shake for Picky Eaters" className="w-full h-[22rem] md:h-[31rem] object-cover rounded-md shadow-md" />
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-white">Picky Eaters Guide</h3>
              <p className="text-gray-300 mb-6">
                Struggling with limited food choices? This guide provides strategies and alternatives for picky eaters to maintain a healthy diet while staying within their comfort zone.
              </p>
              <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/flavorful-gains/" target="_blank" rel="noopener noreferrer">GET THE GUIDE</Button>
            </div>

            {/* 8-Week Weight Loss Program */}
            <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
              <div className="text-red-600 mb-6">
                <Dumbbell size={48} />
              </div>
              <div className="mb-6">
                <img src="/weightloss.png" alt="8-Week Weight Loss Program" className="w-full h-[22rem] md:h-[31rem] object-cover rounded-md shadow-md" />
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-white">8-Week Home Weight Loss Program</h3>
              <p className="text-gray-300 mb-6">
                Lose 8-12 pounds in 8 weeks with our structured home workout and nutrition program. Perfect for busy individuals who want to transform their body from the comfort of their home.
              </p>
              <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/lose-8-12-pounds-in-8-weeks/" target="_blank" rel="noopener noreferrer">START YOUR TRANSFORMATION</Button>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <section className="relative py-20 bg-black">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
          style={{ 
            backgroundImage: "url('https://images.pexels.com/photos/28080/pexels-photo.jpg?auto=compress&cs=tinysrgb&w=1600')"
          }}
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"></div>
        
        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            READY TO BUILD YOUR BEST BODY?
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10">
            Join the program that's transformed countless aussie dreams. <br></br>
            Your transformation starts today.
          </p>
          <div className="relative inline-block">
            <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-16 h-1 bg-red-600"></div>
            <Link to="/contact">
              <Button>START YOUR JOURNEY NOW</Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;